// NGRX
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import {
  AgreementTemplateActions,
  AgreementTemplateActionTypes,
} from '../_actions/agreement-template.actions';
// Models
import { AgreementTemplate } from '../_models/agreement-template.model';
import { QueryParamsModel } from '../../_base/crud/models/query-models/query-params.model';

export interface AgreementTemplatesState extends EntityState<AgreementTemplate> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: any;
  lastCreatedAgreementTemplateId: number;
  lastQuery: QueryParamsModel;
  error: any | null;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
  isAllAgreementTemplatesLoaded: boolean;
  queryRowsCount: number;
  queryResult: AgreementTemplate[];
  allAgreementTemplates: AgreementTemplate[];
}

export const adapter: EntityAdapter<AgreementTemplate> = createEntityAdapter<AgreementTemplate>();

export const initialAgreementTemplatesState: AgreementTemplatesState = adapter.getInitialState({
  isAllAgreementTemplatesLoaded: false,
  queryRowsCount: 0,
  queryResult: [],
  lastCreatedAgreementTemplateId: undefined,
  totalCount: 0,
  listLoading: false,
  actionsloading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  allAgreementTemplates: [],
  error: null,
  latestSuccessfullAction: null,
});

export function agreementTemplatesReducer(
  state = initialAgreementTemplatesState,
  action: AgreementTemplateActions,
): AgreementTemplatesState {
  switch (action.type) {
    case AgreementTemplateActionTypes.AgreementTemplatesPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedAgreementTemplateId: undefined,
      };
    case AgreementTemplateActionTypes.AgreementTemplatesActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case AgreementTemplateActionTypes.AgreementTemplateOnServerCreated:
      return {
        ...state,
      };
    case AgreementTemplateActionTypes.AgreementTemplateOnServerUpdated:
      return {
        ...state,
      };
    case AgreementTemplateActionTypes.AgreementTemplateOnServerDeleted:
      return { ...state };
    case AgreementTemplateActionTypes.AgreementTemplatesOnServerDeleted:
      return {
        ...state,
      };
    case AgreementTemplateActionTypes.AgreementTemplateCreated:
      return adapter.addOne(action.payload.agreementTemplate, {
        ...state,
        lastCreatedAgreementTemplateId: action.payload.agreementTemplate.id,
      });
    case AgreementTemplateActionTypes.AgreementTemplateUpdated:
      return adapter.updateOne(action.payload.partialagreementTemplate, state);
    case AgreementTemplateActionTypes.AgreementTemplateDeleted:
      return adapter.removeOne(action.payload.id, state);
    case AgreementTemplateActionTypes.AgreementTemplatesDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case AgreementTemplateActionTypes.AllAgreementTemplatesLoaded:
      return {
        ...state,
        allAgreementTemplates: action.payload.agreementTemplates,
      };
    case AgreementTemplateActionTypes.AgreementTemplatesPageCancelled:
      return {
        ...state,
        listLoading: false,
        showInitWaitingMessage: false,
        queryRowsCount: 0,
        queryResult: [],
        lastQuery: new QueryParamsModel({}),
      };
    case AgreementTemplateActionTypes.AgreementTemplatesPageLoaded:
      return adapter.addMany(action.payload.agreementTemplates, {
        ...initialAgreementTemplatesState,
        listLoading: false,
        allAgreementTemplates: state.allAgreementTemplates,
        queryResult: action.payload.agreementTemplates,
        showInitWaitingMessage: false,
        totalCount: action.payload.totalCount,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    case AgreementTemplateActionTypes.ThrowAgreementTemplateError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case AgreementTemplateActionTypes.FireAgreementTemplateSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
